/**
 * FAQ Schema Components
 * From SchemaMarkup.tsx lines 346-844
 */

import type { FAQItem } from './types';

/**
 * Generic FAQ Schema
 */
export function FAQSchema({ faqs }: { faqs: FAQItem[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

/**
 * Global FAQ Schema Component
 * Convenience wrapper for homepage
 * Accepts optional translated faqs; falls back to hardcoded GLOBAL_FAQS for non-i18n usage.
 */
import { GLOBAL_FAQS } from './data/global-faqs';

export function GlobalFAQSchema({ faqs }: { faqs?: FAQItem[] } = {}) {
  return <FAQSchema faqs={faqs ?? GLOBAL_FAQS} />;
}
